import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import BaseWrapper from "../BaseWrapper";
import {ClaySelect} from "@clayui/form";
import LoadingIndicator from "@clayui/loading-indicator";

type OptionType = {
    name?: string;
    id?: number | string;
};

type FormDropdownSelectProps = {
    name: string;
    label?: string;
    options: OptionType[];
    additionalOnChange?: (value: number | string | null) => void;
    groupClassName?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    isLoading?: boolean;
};

export function FormDropdownSelect(props: FormDropdownSelectProps) {
    const {formState} = useFormContext();

    return (
        <Controller
            name={props.name}
            render={({field, fieldState}) => (
                <BaseWrapper
                    required={props.required}
                    error={fieldState?.error?.message}
                    id={props.name}
                    label={props.label}
                    groupClassName={props.groupClassName}
                    disabled={props.disabled || formState.isLoading}
                >
                    <ClaySelect
                        id={props.name}
                        aria-label={props.label}
                        value={field.value ?? ''}
                        onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            props.additionalOnChange?.(value);
                        }}
                        disabled={props.disabled}
                        required={props.required}
                    >
                        {props.placeholder && (
                            <ClaySelect.Option
                                label={props.placeholder}
                                value=""
                            />
                        )}
                        {props.options.map((opt) => (
                            <ClaySelect.Option
                                key={opt.id}
                                label={opt.name || ""}
                                value={opt.id}
                            />
                        ))}
                    </ClaySelect>
                    {props.isLoading && (
                    <div className="mr-2" style={{
                        position: 'absolute',
                        right: '30px',
                        top: '38px',
                    }}>
                        <LoadingIndicator style={{margin: 0}} displayType="secondary" size="sm"/>
                    </div>
                    )}
                </BaseWrapper>
            )}
        />
    );
}

export default FormDropdownSelect;
